import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addVirtualDict from '@/components/System/dictionary/addVirtualDict.vue';
import addVirtualDictGroup from '@/components/System/dictionary/addVirtualDictGroup.vue';
export default {
  components: {
    addVirtualDict: addVirtualDict,
    addVirtualDictGroup: addVirtualDictGroup
  },
  data: function data() {
    return {
      btnType: 'search',
      dictKey: '',
      selectData: [],
      selectedArr: [],
      defaultProps: {
        children: 'children',
        label: 'dictGroupName'
      },
      data: [{
        dictGroupName: '字典分组',
        id: 'Dict',
        children: []
      }],
      tableData: [],
      dictObj: {},
      dictGroupObj: {
        subType: 'add'
      },
      tableJson: [{
        prop: 'systemId',
        label: '子系统',
        minWidth: '100'
      }, {
        prop: 'realDictGroupCode',
        label: '真实字典组键',
        minWidth: '100'
      }, {
        prop: 'status.value',
        label: '状态',
        minWidth: '100'
      }, {
        prop: 'createdBy',
        label: '创建人',
        minWidth: '100'
      }, {
        prop: 'updatedBy',
        label: '修改人',
        minWidth: '100'
      }, {
        prop: 'updatedTime',
        label: '修改时间',
        minWidth: '100'
      }],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        param: {
          realGroupName: '',
          virtualGroupId: '',
          systemId: ''
        }
      },
      loading: false,
      total: 0,
      currentNode: {},
      currentTable: {},
      showAddDate: false,
      showAddDictGroup: false
    };
  },
  created: function created() {
    this.getSystemList(this.getDictList);
  },
  methods: {
    searchForm: function searchForm() {
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
        param: {
          groupId: this.pagination.param.groupId,
          dictname: this.dictKey,
          systemId: this.selectedArr[0]
        }
      };
    },
    exportTable: function exportTable() {},
    clickDep: function clickDep(e) {
      if (!e.children) {
        this.currentNode = e;
        this.$refs.dictTree.setCurrentKey(e.id);
        this.pagination = {
          pageSize: 10,
          pageNum: 1,
          param: {
            realGroupName: this.pagination.param.realGroupName,
            virtualGroupId: e.id,
            systemId: this.selectedArr[0]
          }
        };
      }
    },
    renderContent: function renderContent(h, _ref) {
      var node = _ref.node,
        data = _ref.data;
      var that = this;
      if (data.children) {
        return h('span', {
          class: 'tree-node wrap-tree-node'
        }, [h('span', null, node.label), h('span', null, [h('i', {
          class: 'el-icon-plus',
          title: '新增',
          on: {
            click: function click(e) {
              if (that.selectedArr.length === 0) {
                return that.$message({
                  message: '请先选择子系统',
                  type: 'warning'
                });
              }
              that.dictGroupObj = {
                systemId: that.selectedArr[0],
                selectData: that.selectData,
                subType: 'add'
              };
              that.showAddDictGroup = true;
              e.stopImmediatePropagation();
            }
          }
        })])]);
      } else {
        return h('span', {
          class: 'tree-node wrap-tree-node'
        }, [h('span', null, node.label), h('span', null, [h('i', {
          class: 'el-icon-edit-outline',
          title: '编辑',
          on: {
            click: function click(e) {
              that.dictGroupObj = {
                selectData: that.selectData,
                systemId: that.selectedArr[0],
                dictGroupCode: data.dictGroupCode,
                dictGroupName: data.dictGroupName,
                subType: 'edit',
                id: data.id
              };
              that.showAddDictGroup = true;
              e.stopImmediatePropagation();
            }
          }
        }), h('i', {
          class: 'el-icon-delete',
          title: '删除',
          on: {
            click: function click() {
              var _this = this;
              that.$confirm('确认删除?', '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                that.$API.delRequest({
                  url: "/platform/dict/deleteDictGroup/".concat(data.id)
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    that.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                    _this.getDictGroupList();
                  }
                });
              });
            }
          }
        })])]);
      }
    },
    changeSystemId: function changeSystemId() {
      this.getDictGroupList();
      this.pagination = {
        pageSize: 10,
        pageNum: 1,
        param: {
          realGroupName: this.pagination.param.realGroupName,
          virtualGroupId: this.pagination.param.virtualGroupId,
          systemId: this.selectedArr[0]
        }
      };
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.currentTable = e;
    },
    addDateFn: function addDateFn() {
      if (!this.currentNode.dictGroupCode) {
        return this.$message({
          type: 'warning',
          message: '请选择分组'
        });
      }
      this.dictObj = {
        systemId: this.selectedArr[0],
        selectData: this.selectData,
        id: this.currentNode.id
      };
      this.showAddDate = true;
    },
    editDateFn: function editDateFn() {
      if (this.currentTable) {
        //     this.$API.getRequest({url:`/platform/virtualDict/deleteRelation/${this.currentTable.id}`}).then(res =>{
        //       this.getDictList()
        // })
      } else {
        this.$message({
          type: 'warning',
          message: '请先选择真实字典'
        });
      }
    },
    deleteDateFn: function deleteDateFn() {
      var _this2 = this;
      if (this.currentTable) {
        this.$API.getRequest({
          url: "/platform/virtualDict/deleteRelation/".concat(this.currentTable.id)
        }).then(function () {
          _this2.getDictList();
        });
      } else {
        this.$message({
          type: 'warning',
          message: '请先选择真实字典'
        });
      }
    },
    getSystemList: function getSystemList(callback) {
      var _this3 = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        _this3.selectData = res.result;
        callback && callback();
      }, function () {});
    },
    getDictGroupList: function getDictGroupList() {
      var _this4 = this;
      this.$API.getRequest({
        url: "/platform/virtualDict/searchDictGroup/".concat(this.selectedArr[0])
      }).then(function (res) {
        _this4.data[0].children = res.result;
        _this4.$nextTick(function () {
          _this4.currentNode = {};
          _this4.$refs.dictTree.setCurrentKey(null);
        });
      });
    },
    getDictList: function getDictList() {
      var _this5 = this;
      this.loading = true;
      this.$API.postRequest({
        url: '/platform/virtualDict/searchRelation',
        data: this.pagination
      }).then(function (res) {
        _this5.loading = false;
        if (res.code === '0000000000') {
          _this5.total = res.result.total;
          _this5.tableData = res.result.list.map(function (item) {
            item.systemName = _this5.selectData.find(function (ite) {
              return ite.systemId === item.systemId;
            }).systemName;
            return item;
          });
        }
      });
    },
    close: function close(key) {
      this[key] = false;
    }
  },
  watch: {
    pagination: {
      handler: function handler() {
        this.getDictList();
      },
      deep: true
    }
  }
};